import { motion } from "framer-motion";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";
import { useNavigate } from "react-router-dom";

const benefits = [
  {
    icon: "Users",
    text: "Connect with clients actively searching for your services",
  },
  {
    icon: "Star",
    text: "Build your professional reputation with verified reviews",
  },
  {
    icon: "Trophy",
    text: "Showcase your expertise, credentials, and portfolio",
  },
  {
    icon: "MessageCircle",
    text: "Manage client communications through our secure platform",
  },
];

export function JoinSection() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    profession: "",
    city: "",
    phone: "",
    message: "",
  });
  const navigate = useNavigate();

  return (
    <section
      id="join"
      className="py-16 bg-gradient-to-br"
      style={{
        background: "linear-gradient(135deg, rgb(106, 0, 244), rgb(111, 109, 248))"
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto text-center mb-10"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Are You a Real Estate or Lending Professional?
          </h2>
          <p className="text-lg text-white/90 leading-relaxed">
            Join our network of trusted professionals to expand your client base
            and grow your business. Get listed in our directory and start
            receiving client inquiries today.
          </p>
        </motion.div>

        {/* Benefits */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto mb-10"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {benefits.map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: index % 2 === 0 ? -30 : 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="flex items-start bg-white/10 backdrop-blur-sm rounded-lg p-4"
              >
                <div className="text-yellow-300 h-7 w-7 mr-3 mt-1 flex-shrink-0">
                  ⭐
                </div>
                <span className="text-white text-base leading-relaxed">
                  {benefit.text}
                </span>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Call to Action */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <p className="text-white/90 mb-6 text-lg">
            Ready to grow your business with qualified leads?
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              size="lg"
              className="bg-[#f1c40f] text-purple hover:bg-[#e2b90e] px-6 py-3 text-base font-semibold shadow-lg"
              onClick={() => navigate("/vendor/auth/register")}
            >
              Create Professional Profile
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-white text-black hover:bg-white hover:text-purple px-6 py-3 text-base font-semibold"
            >
              <Phone className="mr-2 h-5 w-5" />
              Call Us: 0406 364 893
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
